var map = {
	"./chlg-logo-colour.png": "4f50",
	"./currie-cup-logo-colour.png": "d9e8",
	"./cwc-logo-colour.png": "adb3",
	"./epl-logo-colour.png": "ce73",
	"./euro-logo-colour.png": "dd50",
	"./european-championship-2024-logo-colour.png": "2ce4",
	"./fifa-world-cup-logo-colour.png": "88a1",
	"./icc-men's-cricket-world-cup-2023-logo-colour.png": "d7e0",
	"./icc-t20-world-cup-logo-colour.png": "c562",
	"./m-logo-colour.png": "4292",
	"./natl-logo-colour.png": "c994",
	"./psl-logo-colour.png": "628e",
	"./rwc-logo-colour.png": "db54",
	"./sad-logo-colour.png": "ea47",
	"./safr-logo-colour.png": "5736",
	"./t20-cup-logo-colour.png": "8c42",
	"./united-rugby-championship-logo-colour.png": "7217",
	"./urc-logo-colour.png": "618c",
	"./women's-world-cup-logo-colour.png": "9710",
	"./wwc-logo-colour.png": "818f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e50";